import React from "react";

import {
  TranslatedInfo,
  Translations,
  websiteLanguages,
} from "../../generic/i18n";

import { drWajmaMangal } from "./employees/drWajmaMangal";
import { elizabethHincapieH } from "./employees/elizabethHHincapie";
import { gretaNeubauerKonradies } from "./employees/gretaNeuerbauerKonradies";
import { torbenSchwarzer } from "./employees/torbenSchwarzer";
import { lidaSaldjuki } from "./employees/lida-saldjuki";

import { drUlePfeiffer } from "./employees/drUlePfeiffer";
import { amelieKorn } from "./employees/amelieKorn";
import { drJanHeilmann } from "./employees/drJanHeilmann";
import { solveigWindt } from "./employees/solveig-windt";

export type Employee = {
  slug: string;
  displayName: string;
  linkedInLink?: string | undefined;
  title:
    | "legal-assistant-male"
    | "legal-assistant-female"
    | "lawyer-male"
    | "lawyer-male-ir"
    | "lawyer-female"
    | "lawyer-partner-female"
    | "lawyer-partner-male"
    | "office-manager-female"
    | "student-assistant-male"
    | "student-assistant-female"
    | "personal-assistant-female"
    | "fully-qualified-lawyer-female";
  isExternal?: boolean | undefined;
  isCounsel?: boolean | undefined;
  subTitle?: string | undefined;
  secondTitle?: string | undefined;
  hasProfile?: boolean | undefined;
  languages: Language[];

  img: string;
  additionalQualifications?: string[] | undefined;
  awards?: string[] | undefined;
  translations?: Translations<EmployeeTranslatedInfo>[] | undefined;
  displayNameSuffix?: string | undefined;
};

export interface EmployeeTranslatedInfo {
  memberships?: string[] | undefined;
  awards?: string[] | undefined;
  publications?: Publication[] | undefined;
  expertTalks?: Publication[] | undefined;
  additionalQualifications?: string[] | undefined;
  certifications?: string[] | undefined;
  positions?: string[] | undefined;
}

export type Publication = {
  title: string;
  date: string;
  location?: string | undefined;
  link?: string | undefined;
};

export type Language = "deu" | "eng" | "pst" | "prs" | "rus" | "esp" | "fra";

export const employeeList: Employee[] = [
  drWajmaMangal,
  drJanHeilmann,
  torbenSchwarzer,
  elizabethHincapieH,
  gretaNeubauerKonradies,
  drUlePfeiffer,
  solveigWindt,
];
